import React from "react";
import { FormSelect } from "@jsq/ds/forms";
import { CurrencyCode } from "#graphql/supergraphEnums";
import { CURRENCY_CODE_TO_NAME_MAP } from "../../../Money/constants";
import { getFullNameAndCodeForCurrency } from "../../../Money/utils";

type Props = {
  name: string;
  label?: string;
  handleChange?: (value: string | number | string[] | number[]) => void;
  disabled?: boolean;
};

const CURRENCY_OPTIONS = Object.values(CurrencyCode).map((code) => ({
  code,
  label: getFullNameAndCodeForCurrency({ fullName: CURRENCY_CODE_TO_NAME_MAP[code], code }),
}));

/**
 * Currency picker over the full `CurrencyCode` enum. Options are labelled with
 * the currency's full name and ISO code.
 */
export const CurrencySelect: React.FC<Props> = ({
  name,
  label = "Currency",
  handleChange = undefined,
  disabled = false,
}) => (
  <FormSelect
    name={name}
    full
    label={label}
    placeholder="Select a currency"
    handleChange={handleChange}
    disabled={disabled}
    data-cy={`${name}-currency`}
    data-testid={`${name}-currency`}
  >
    <FormSelect.Section>
      {CURRENCY_OPTIONS.map((currency) => (
        <FormSelect.Option key={currency.code} value={currency.code}>
          {currency.label}
        </FormSelect.Option>
      ))}
    </FormSelect.Section>
  </FormSelect>
);
